var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"persion"},[_c('van-nav-bar',{staticClass:"barColor",attrs:{"title":_vm.$t('邮箱'),"right-text":_vm.$t('提交'),"left-arrow":""},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}}),_c('div',{staticClass:"persion-card"},[_c('div',{staticClass:"email"},[_vm._v(_vm._s(_vm.$t('请填写你的邮箱')))])]),_c('div',{staticClass:"persion-card"},[_c('van-form',{ref:"form",on:{"submit":_vm.onClickRight}},[_c('van-field',{staticClass:"nameText",attrs:{"rules":[
          {
            pattern:
              /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
            message: _vm.$t('邮箱地址格式不正确！'),
          },
        ]},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }